import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserProfileVTO } from '../../../services/profile-service.model';
import { UpdateProfileComponent } from '../../../components/admin-customer-shared-components/update-profile-component/update-profile-component';

@Component({
  selector: 'app-update-profile',
  standalone: true,
  imports: [CommonModule, UpdateProfileComponent],
  templateUrl: './update-profile.html',
  styleUrls: ['./update-profile.scss'],
})
export class UpdateProfile {}
